import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CHANGE_SUBSCRIPTION_PLAN: `${cleanedFilename(
    __filename,
  )}-change-subscription-plan`,
};
